const TRUTHY = new Set(['true', '1', 'yes', 'on']);

export function parseMaintenanceFlag(value?: string | null): boolean {
    if (value == null) return false;
    return TRUTHY.has(value.trim().toLowerCase());
}

/** Server / edge — reads `UNDER_MAINTENANCE`. */
export function isUnderMaintenance(): boolean {
    return parseMaintenanceFlag(process.env.UNDER_MAINTENANCE);
}

/** Browser — synced from `UNDER_MAINTENANCE` via next.config `env`. */
export function isUnderMaintenanceClient(): boolean {
    return parseMaintenanceFlag(process.env.NEXT_PUBLIC_UNDER_MAINTENANCE);
}

/** Static assets — skip middleware so images/fonts still load on `/`. */
export function isStaticAssetPath(pathname: string): boolean {
    if (pathname.startsWith('/_next/static') || pathname.startsWith('/_next/image')) {
        return true;
    }
    if (pathname === '/favicon.ico' || pathname === '/robots.txt' || pathname === '/sitemap.xml') {
        return true;
    }
    return /\.(?:svg|png|jpg|jpeg|gif|webp|ico|woff2?|ttf|eot|css|js|map|json|txt)$/i.test(pathname);
}

/** Routes that required auth before maintenance mode was introduced. */
export const AUTH_PROTECTED_PREFIXES = [
    '/expenses',
    '/analysis',
    '/planning',
    '/financial',
    '/integrations',
    '/agents',
    '/automated-collection',
    '/cost-allocation',
    '/data-enrichment',
    '/csv-data-enrichment',
    '/kpis-dashboard',
    '/protected',
    '/settings',
    '/treasury',
    '/business-plan',
    '/restaura',
    '/welcome',
    '/pricing',
] as const;

export function isAuthProtectedPath(pathname: string): boolean {
    return AUTH_PROTECTED_PREFIXES.some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
    );
}

export const MAINTENANCE_API_MESSAGE =
    'Blueberries is temporarily unavailable for scheduled maintenance.';
